import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import PageWrapper from 'components/ui/PageWrapper';
import EmbedFrame from 'components/core/EmbedFrame';
import { iframeSrcAppendQuery } from 'utils/iframe';

const IFramePage = (props) => {
  const { userId, frameSrc, appendQuery } = props;
  const { key, search } = useLocation();
  let src = frameSrc.replace('{#userId}', userId);
  if (appendQuery) {
    src = iframeSrcAppendQuery(src, search); //append query strings
  }
  return (
    <PageWrapper>
      <EmbedFrame frameSrc={src} locationKey={key} />
    </PageWrapper>
  );
};

IFramePage.propTypes = {
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  frameSrc: PropTypes.string.isRequired,
  noAppendQuery: PropTypes.bool,
};

IFramePage.defaultProps = {
  appendQuery: true,
};
export default connect(
  (state) => ({
    userId: state.auth.userId,
  }),
  null
)(IFramePage);
